import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Base from '../Base';
import { Slider } from '@Sage/hoi-poi-ui';

const propTypes = {
    label: PropTypes.any,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
    value: PropTypes.any,
    className: PropTypes.string,
    error: PropTypes.any,
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    filter: PropTypes.func,
    format: PropTypes.func,
    min: PropTypes.number,
    max: PropTypes.number,
    description: PropTypes.string,
    labelMode: PropTypes.string,
};

class PercentSlider extends PureComponent {
    constructor(props) {
        super(props);
        this.debounce = null;
        this.state = {};
    }

    onChange = (newValue) => {
        const { onChange } = this.props;
        this.setState({ value: newValue });
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            onChange && onChange(newValue);
        }, 400);
    };

    renderError = () => {
        let { error } = this.props;

        if (!error || typeof error === 'object') return null;
        return <div className="fm-field-error">{error}</div>;
    };

    render() {
        const {
            label,
            description,
            hidden,
            mandatory,
            readOnly,
            value,
            labelMode,
            min = 0,
            max = 100,
            step = 1,
            isBulkAction,
            canToggle,
            fieldExtraValue,
        } = this.props;

        if (hidden) return null;

        let finalValue = !this.state.value ? Number(value) : this.state.value;

        return (
            <Base
                className="fm-field-input"
                parentClassName="fm-field-container-slider"
                label={label}
                mandatory={mandatory}
                description={description}
                labelMode={labelMode}
                isBulkAction={isBulkAction}
                onReset={this.props.onChange}
                canToggle={canToggle}
                fieldExtraValue={fieldExtraValue}
            >
                <Slider
                    className="fm-field-slider"
                    value={finalValue}
                    onChange={this.onChange}
                    max={max}
                    min={min}
                    step={step}
                    isReadOnly={readOnly}
                    tipFormatter={(value) => `${value * 10}%`}
                />
                {this.renderError()}
            </Base>
        );
    }
}

PercentSlider.propTypes = propTypes;

export default PercentSlider;
